import type { FC } from 'react';

import cx from 'classnames';

import type { BadgeProps } from './BadgeElement.types';

const COLORS = {
  warning: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  alert: 'bg-red-100 text-red-800 border-red-200',
  success: 'bg-green-100 text-green-800 border-green-200',
  information: 'bg-gray-100 text-gray-800 border-gray-200',
  info_blue: 'bg-blue-100 text-blue-800 border-blue-200',
  tertiary: 'bg-action-tertiary-50 text-action-tertiary-900 border-action-tertiary-200',
};

const BadgeElement: FC<BadgeProps> = ({ type = 'information', size = 'md', children, className = '' }: BadgeProps) => {
  if (!children) return null;

  const colorClasses = COLORS[type] ?? 'bg-gray-100 text-gray-800';

  return (
    <span
      className={cx(
        'shadow-xs inline-flex items-center gap-x-1 rounded-md border border-gray-300 text-xs font-medium',
        className,
        colorClasses,
        { 'h-4.5 px-1.5 text-xs': size === 'sm' },
        { 'h-5.5 px-2.5 py-0.5': size === 'md' },
      )}
    >
      {children}
    </span>
  );
};

export default BadgeElement;
